import { formatCurrency } from '@/utils/currency'
import { formatNumber } from '@/utils/number'
import { sign, formatPercentage } from '@/utils/number'
import { getIcon } from '@/utils/image'

export const tickerTransformer = (item, context) => {
  const { currency } = context
  const minimumFractionDigits = 2
  const quote = item.quote[currency]

  return {
    change24h: {
      text: formatNumber(quote.percentage_change_24h / 100, context, { style: 'percent' }),
      sign: sign(quote.percentage_change_24h),
    },
    name: item.name,
    price: { text: formatCurrency(quote.price, context, { minimumFractionDigits }) },
  }
}

export const tableTransformer = (item, context) => {
  const { currency } = context
  const minimumFractionDigits = 2
  const quote = item.quote[currency]

  return {
    change1h: {
      text: formatNumber(quote.percentage_change_1h / 100, context, { style: 'percent' }),
      sign: sign(quote.percentage_change_1h),
    },
    change24h: {
      text: formatNumber(quote.percentage_change_24h / 100, context, { style: 'percent' }),
      sign: sign(quote.percentage_change_24h),
    },
    change7d: {
      text: formatNumber(quote.percentage_change_7d / 100, context, { style: 'percent' }),
      sign: sign(quote.percentage_change_7d),
    },
    circulatingSupply: {
      text: formatNumber(item.circulating_supply, context, { minimumFractionDigits: 0, maximumFractionDigits: 3 }),
    },
    icon: getIcon(item.name),
    marketCapLong: {
      text: formatNumber(quote.market_cap, context, {
        notation: 'compact',
        compactDisplay: 'long',
        maximumFractionDigits: 0,
      }),
    },
    name: item.name,
    offer: item.offer,
    permalink: item.permalink,
    price: { text: formatCurrency(quote.price, context, { minimumFractionDigits }) },
    symbol: { text: item.symbol },
    totalSupply: {
      text: formatNumber(item.total_supply, context, {
        notation: 'compact',
        compactDisplay: 'long',
        maximumFractionDigits: 0,
      }),
    },
    volume24h: {
      text: formatNumber(quote.volume_24h, context, {
        notation: 'compact',
        compactDisplay: 'long',
        maximumFractionDigits: 0,
      }),
    },
  }
}

export const chartTransformer = (item, context) => {
  const { currency } = context
  const minimumFractionDigits = 2
  const quote = item.quote[currency]
  const compactCirculatingSupply = formatNumber(item.circulating_supply, context, {
    notation: 'compact',
    maximumFractionDigits: 1,
  })
  const compactVolume24h = formatCurrency(quote.volume_24h, context, { notation: 'compact', compactDisplay: 'long' })

  return {
    cols: [
      { header: 'market-cap', text: formatCurrency(quote.market_cap, context, { notation: 'compact' }) },
      { header: 'volume-24-hours', text: compactVolume24h },
      {
        header: 'circulating-supply',
        text: `${compactCirculatingSupply} ${item.symbol}`,
      },
    ],
    icon: getIcon(item.name),
    name: item.name,
    price: { text: formatCurrency(quote.price, context, { minimumFractionDigits }) },
    symbol: { text: item.symbol },
  }
}

export const latestPriceTransformer = (item, context) => {
  const { currency } = context
  const quote = item.quote[currency]
  return formatCurrency(quote.price, context, { minimumFractionDigits: 2 })
}

export const chartCardLatestTransaformer = (item, context) => {
  const difference = (item.present.price - item.past.price).toFixed(2)
  const differenceFormatted = formatCurrency(difference, context, { minimumFractionDigits: 2 })

  const isset = value => value != null

  return {
    price: isset(difference) ? formatCurrency(item.present.price, context, { minimumFractionDigits: 2 }) : '',
    changePercentage: formatPercentage(item.differencePercent),
    difference: isset(difference)
      ? Math.sign(difference) === 1
        ? `+${differenceFormatted}`
        : differenceFormatted
      : '',
  }
}
